export default function OptionDisplay({
  value,
  options,
  multi = false,
  fallback = "Not Specified",
}) {
  if (!value) return fallback;

  const values = multi ? value.split(",").map(v => v.trim()) : [value];

  const labels = values
    .map(v => options.find(opt => opt.value === v)?.label)
    .filter(Boolean);

  if (labels.length === 0) return fallback;

  return labels.join(", ");
}